import React, {createContext, PropsWithChildren, useContext, useState} from "react";

import {IMyPlaceFormValues} from "../components/ComparisonToolTable/MyPlaceModal";
import {comparisonToolAnalytics, ComparisonToolGTMTableAction} from "../utils/comparison_tool_analytics";

interface ComparisonToolContextValue {
    /*
        My place
     */
    changeMyPlaceModalOpened: boolean;
    setChangeMyPlaceModalOpened: (opened: boolean) => void;
    myPlace: IMyPlaceFormValues | null;
    setMyPlace: (newPlace: IMyPlaceFormValues | null) => void;
    /*
        Print
     */
    isPrinting: boolean;
    print: () => void;
    /*
        Plan modal
     */
    selectedPropertyPlan: ISelectedPlan | null;
    selectPropertyPlan: (planData: ISelectedPlan | null) => void;
    /*
        Ask for all modal
     */
    askForAllModalOpened: boolean;
    setAskForAllModalOpened: (opened: boolean) => void;
}

export interface ISelectedPlan {
    propertyId: number;
    propertyTableIndex: number;
}

const ComparisonToolContext = createContext<null | ComparisonToolContextValue>(null);

export const ComparisonToolContextProvider = (props: PropsWithChildren<{}>) => {
    const {children} = props;

    const [changeMyPlaceModalOpened, setChangeMyPlaceModalOpened] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const [myPlace, setMyPlace] = useState<null | IMyPlaceFormValues>(null);
    const [selectedPropertyPlan, selectPropertyPlan] = useState<null | ISelectedPlan>(null);
    const [askForAllModalOpened, setAskForAllModalOpened] = useState(false);

    return (
        <ComparisonToolContext.Provider
            value={{
                changeMyPlaceModalOpened,
                setChangeMyPlaceModalOpened: (opened) => {
                    setChangeMyPlaceModalOpened(opened);
                },
                myPlace,
                setMyPlace: (newPlace) => {
                    setMyPlace(newPlace);
                },
                isPrinting,
                print: async () => {
                    comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.PDF_DOWNLOAD);
                    setIsPrinting(true);
                    window.print();
                    setIsPrinting(false);
                },
                selectedPropertyPlan,
                selectPropertyPlan: (planData) => {
                    comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.SHOW_PROJECTION_CLICK);
                    selectPropertyPlan(planData);
                },
                askForAllModalOpened,
                setAskForAllModalOpened: (opened) => {
                    setAskForAllModalOpened(opened);
                }
            }}
        >
            {children}
        </ComparisonToolContext.Provider>
    );
};

export const useComparisonToolContext = () => {
    const ctx = useContext(ComparisonToolContext);

    if (!ctx) {
        throw new Error("ComparisonToolContext not provided");
    }

    return ctx;
};
import React, {createContext, PropsWithChildren, useContext, useState} from "react";

import {IMyPlaceFormValues} from "../components/ComparisonToolTable/MyPlaceModal";
import {comparisonToolAnalytics, ComparisonToolGTMTableAction} from "../utils/comparison_tool_analytics";

interface ComparisonToolContextValue {
    /*
        My place
     */
    changeMyPlaceModalOpened: boolean;
    setChangeMyPlaceModalOpened: (opened: boolean) => void;
    myPlace: IMyPlaceFormValues | null;
    setMyPlace: (newPlace: IMyPlaceFormValues | null) => void;
    /*
        Print
     */
    isPrinting: boolean;
    print: () => void;
    /*
        Plan modal
     */
    selectedPropertyPlan: ISelectedPlan | null;
    selectPropertyPlan: (planData: ISelectedPlan | null) => void;
    /*
        Ask for all modal
     */
    askForAllModalOpened: boolean;
    setAskForAllModalOpened: (opened: boolean) => void;
}

export interface ISelectedPlan {
    propertyId: number;
    propertyTableIndex: number;
}

const ComparisonToolContext = createContext<null | ComparisonToolContextValue>(null);

export const ComparisonToolContextProvider = (props: PropsWithChildren<{}>) => {
    const {children} = props;

    const [changeMyPlaceModalOpened, setChangeMyPlaceModalOpened] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const [myPlace, setMyPlace] = useState<null | IMyPlaceFormValues>(null);
    const [selectedPropertyPlan, selectPropertyPlan] = useState<null | ISelectedPlan>(null);
    const [askForAllModalOpened, setAskForAllModalOpened] = useState(false);

    return (
        <ComparisonToolContext.Provider
            value={{
                changeMyPlaceModalOpened,
                setChangeMyPlaceModalOpened: (opened) => {
                    setChangeMyPlaceModalOpened(opened);
                },
                myPlace,
                setMyPlace: (newPlace) => {
                    setMyPlace(newPlace);
                },
                isPrinting,
                print: async () => {
                    comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.PDF_DOWNLOAD);
                    setIsPrinting(true);
                    window.print();
                    setIsPrinting(false);
                },
                selectedPropertyPlan,
                selectPropertyPlan: (planData) => {
                    comparisonToolAnalytics.gtm.tableEvent(ComparisonToolGTMTableAction.SHOW_PROJECTION_CLICK);
                    selectPropertyPlan(planData);
                },
                askForAllModalOpened,
                setAskForAllModalOpened: (opened) => {
                    setAskForAllModalOpened(opened);
                }
            }}
        >
            {children}
        </ComparisonToolContext.Provider>
    );
};

export const useComparisonToolContext = () => {
    const ctx = useContext(ComparisonToolContext);

    if (!ctx) {
        throw new Error("ComparisonToolContext not provided");
    }

    return ctx;
};
